import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as PresentationModeActions from './presentation-mode.actions';
import * as PresentationModeSelectors from './presentation-mode.selectors';
import { Observable } from 'rxjs';

@Injectable()
export class PresentationModeFacade {
  constructor(private readonly store: Store) {}

  public getPresentationModeState(): Observable<boolean | null> {
    return this.store.pipe(select(PresentationModeSelectors.getPresentationModeState()));
  }

  public togglePresentationMode(): void {
    this.store.dispatch(PresentationModeActions.togglePresentationMode());
  }

  public initPresentationMode(status: boolean): void {
    this.store.dispatch(PresentationModeActions.initPresentationMode({ isPresentationMode: status }));
  }
}
